var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['product-tabs__pane', {
        'product-tabs__pane--is-active': _vm.active,
        'product-tabs__pane--is-not-active': !_vm.active
}],attrs:{"id":_vm.name,"role":"tabpanel"}},[_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }